import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

const cardTitleStyles = css`
  font-size: 18px;
  line-height: 24px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

const containerStyles = css`
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  border: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
  border-radius: 8px;
  margin-top: 8px;
  padding: 18px;
  padding-bottom: 10px;
  font-size: 15px;
  line-height: 16px;

  &:last-of-type {
    margin-bottom: 10px;
  }
`;

const imgStyles = css`
  height: 24px;
  width: 24px;
  margin-right: 10px;
  border-radius: 4px;
  display: inline-block;
`;

const Row = styled.div<{ hasComponents: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.hasComponents ? "14px" : "10px")
  };
`;

interface IProps {
  dataTestId?: string;
  title: string | React.ReactNode;
  children?: React.ReactNode;
  img?: string;
  onClick?: (event?: React.MouseEvent) => void;
}

const StyledIcon = styled(Icon)`
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.headerColor
  };
  cursor: pointer;
`;

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'dataTestId' is declared but its value is never re... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
export const DetailsCard = ({ img, title, children, onClick, dataTestId }: IProps) => {
  const hasComponents = React.Children.count(children) >= 1;
  return (
    <div css={containerStyles}>
      <Row hasComponents={hasComponents}>
        {img && <img src={img} css={imgStyles} />}
        <div css={cardTitleStyles}>{title}</div>
        {onClick && (
          <div onClick={onClick}>
            <StyledIcon name={IconsEnum.ArrowRight} width="16px" height="16px" />
          </div>
        )}
      </Row>
      {children}
    </div>
  );
};
